// extracted by mini-css-extract-plugin
module.exports = {"container":"SpvAdminDocuments_container__1BXYQ","cell":"SpvAdminDocuments_cell__1OYdB"};